import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import Navbar from "./components/Navbar.vue";
import { useRouter } from "vue-router";
import { ref } from "vue";
import AdminPage from "./views/Admin/AdminPage.vue";
import Login from "./views/Admin/Login.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const showNavbar = ref(false);
const showAdminPage = ref(false);
const showLoginPage = ref(false);
const router = useRouter();

router.beforeEach((to, from, next) => {
  // Conditionally hide navbar on certain routes
  if (to.path.startsWith('/admin')) {
    showAdminPage.value = true;
    showNavbar.value = false;
    showLoginPage.value = false;
  } else {
    showNavbar.value = true
    showAdminPage.value = false;
  }

  if (to.path === "/login") {
    showNavbar.value = false;
    showLoginPage.value = true;
  }
  next();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showNavbar.value)
      ? (_openBlock(), _createBlock(Navbar, { key: 0 }))
      : _createCommentVNode("", true),
    (showAdminPage.value)
      ? (_openBlock(), _createBlock(AdminPage, { key: 1 }))
      : _createCommentVNode("", true),
    (showLoginPage.value)
      ? (_openBlock(), _createBlock(Login, { key: 2 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})